<template>
    <div>
        <div ref="widgetContainer"></div>
    </div>
</template>

<script>
export default {
    props: {
        snippet: { type: String, default: '' },
    },
    watch: {
        snippet: {
            immediate: true,
            handler(newSnippet) {
                if (!newSnippet) return

                this.$nextTick(() => {
                    const container = this.$refs.widgetContainer
                    if (container) {
                        container.innerHTML = ''
                        const parser = new DOMParser()
                        const doc = parser.parseFromString(newSnippet, 'text/html')
                        const scripts = Array.from(doc.querySelectorAll('script[src]'))
                        scripts.forEach((s) => s.remove())
                        while (doc.body.firstChild) {
                            container.appendChild(doc.body.firstChild)
                        }
                        scripts.forEach((oldScript) => {
                            const newScript = document.createElement('script')
                            Array.from(oldScript.attributes).forEach((attr) => {
                                newScript.setAttribute(attr.name, attr.value)
                            })
                            newScript.textContent = oldScript.textContent
                            container.appendChild(newScript)
                        })
                    }
                })
            },
        },
    },
}
</script>
